import { $scroll } from '../stores/scroll';
import { Scroll } from '../classes/Scroll';

export default class Progress extends HTMLElement {
  constructor() {
    super();

    // Binding
    this.handleIntersection = this.handleIntersection.bind(this);

    // UI
    this.target = this.querySelector('[data-progress-target]')
      ? this.querySelector('[data-progress-target]')
      : this.children[0];

    this.$itemsContainer = this.querySelector('[data-progress-items]');

    // Config
    this.observerOptions = {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    };

    // Data
    this.value = this.dataset?.value ? this.dataset.value : 0;
    this.style.setProperty('--progress', this.value);
    this.sections = [];
    this.links = [];
    this.activeSection = null;
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.buildLinks();
    this.bindEvents();
    this.initIntersectionObserver();
    this.update($scroll.get().progress);
  }

  disconnectedCallback() {
    this.unbindEvents();
    this.destroyIntersectionObserver();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {
    this.unsubscribe = $scroll.subscribe(state => this.update(state.progress));
  }

  unbindEvents() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  update(value) {
    this.value = value;
    this.style.setProperty('--progress', this.value);
  }

  ///////////////
  // Methods
  ///////////////

  buildLinks() {
    // Находим все секции с data-progress-section
    this.sections = Array.from(document.querySelectorAll('[data-progress-section]'));

    if (!this.sections.length || !this.$itemsContainer) return;

    // Очищаем контейнер
    this.$itemsContainer.innerHTML = '';
    this.links = [];

    // Создаем ссылки для каждой секции
    this.sections.forEach((section, index) => {
      const id = section.id;

      if (!id) return; // Пропускаем если нет id

      // Создаем элемент ссылки
      const link = document.createElement('button');
      link.setAttribute('data-no-swup', '');
      link.setAttribute('data-scroll-to', '');
      link.setAttribute('data-scroll-to-offset', '0');
      link.style.setProperty('--index', index);
      link.setAttribute('data-scroll-to-id', id);
      link.className = 'c-progress_link';

      // Создаем span с текстом (id как текст)
      const span = document.createElement('span');
      span.className = 'c-progress_link_span';
      span.textContent = id.split('-')[0];

      // Создаем точку
      const dot = document.createElement('div');
      const dotInner = document.createElement('span');
      dotInner.className = 'c-progress_line_dot_span';

      dot.className = 'c-progress_line_dot';
      dotInner.textContent = id.split('-')[0];
      dot.appendChild(dotInner);

      // Собираем структуру
      link.appendChild(span);
      link.appendChild(dot);

      // Добавляем в контейнер
      this.$itemsContainer.appendChild(link);

      // Сохраняем ссылку для дальнейшего использования
      this.links.push({ element: link, id, section });
    });

    this.$itemsContainer.addEventListener('click', e => {
      const target = e.target.closest('button');
      if (!target) return;

      const id = target.dataset.scrollToId;

      if (!id) return;
      e.preventDefault();

      Scroll.scrollTo(document.getElementById(id));
    });
  }

  initIntersectionObserver() {
    if (!this.sections.length) return;

    this.observer = new IntersectionObserver(this.handleIntersection, this.observerOptions);

    // Наблюдаем за всеми секциями
    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  destroyIntersectionObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.setActiveSection(entry.target.id);
      }
    });
  }

  setActiveSection(sectionId) {
    if (this.activeSection === sectionId) return;

    this.activeSection = sectionId;

    // Убираем активный класс со всех ссылок
    this.links.forEach(({ element, id }) => {
      if (id === sectionId) {
        element.classList.add('is-active');
      } else {
        element.classList.remove('is-active');
      }
    });
  }

  destroy() {
    this.unbindEvents();
    this.destroyIntersectionObserver();
  }
}
